import React, { useRef, useEffect } from 'react';
import gsap from 'gsap';

interface MagneticButtonProps {
    children: React.ReactNode;
    className?: string;
    onClick?: () => void;
    scale?: number;
}

const MagneticButton: React.FC<MagneticButtonProps> = ({
    children,
    className = "",
    onClick,
    scale = 1.1
}) => {
    const buttonRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        const button = buttonRef.current;
        if (!button) return;

        const ctx = gsap.context(() => {
            button.addEventListener('mousemove', (e) => {
                const { clientX, clientY } = e;
                const { left, top, width, height } = button.getBoundingClientRect();

                const x = clientX - (left + width / 2);
                const y = clientY - (top + height / 2);

                gsap.to(button, {
                    x: x * 0.2,
                    y: y * 0.2,
                    scale: scale,
                    duration: 0.3,
                    ease: "power2.out"
                });
            });

            button.addEventListener('mouseleave', () => {
                gsap.to(button, {
                    x: 0,
                    y: 0,
                    scale: 1,
                    duration: 0.5,
                    ease: "elastic.out(1, 0.3)"
                });
            });
        }, button);

        return () => ctx.revert();
    }, [scale]);

    return (
        <button
            ref={buttonRef}
            onClick={onClick}
            className={`relative inline-flex items-center justify-center transition-colors ${className}`}
        >
            {children}
        </button>
    );
};

export default MagneticButton;
